import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import FormField from "components/forms/FormField";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { useAuth } from "util/auth.js";
import { useForm } from "react-hook-form";

function AuthForm(props) {
  const auth = useAuth();

  const [pending, setPending] = useState(false);
  const { handleSubmit, register, errors, getValues } = useForm();

  const submitHandlersByType = {
    otp: ({ otpCode }) => {
      // TO DO:
      // - Remove white space
      // - Check if the code is of appropriate length
      console.log("props.phone: ")
      console.log(props.phone)
      const cleanPhoneNumber = props.phone?.replace(/\s/g, "");
      return auth.signinWithOtpCode(otpCode, cleanPhoneNumber).then((status) => {
        // if (result.status.code === Server.error.USER_PROFILE_INCOMPLETE) {
        // ---->>>> TO DO: continue the signup process. Ask for email, etc.
        //   // this.props.navigation.push('UserEmail');
        // } else {
        //   // Finish LOGIN and navigate to the Initial login-protected page that was requested
        //   // this.props.navigation.popToTop();
        // }
        // Call auth complete handler
        if (status) {
          props.onAuth();
        } else {
          setPending(false);
          return false;
        }
      });
    },
    signup: ({ phone }) => {
      const cleanPhoneNumber = phone.replace(/\s/g, "");

      // TO DO:
      // - If phone is null, show alert
      // - Remove white space
      // - Check if the phone is valid
      return auth.signinWithPhone(cleanPhoneNumber).then((status) => {
        // Call auth complete handler
        props.onPhoneEntry(status, cleanPhoneNumber);
      });
    },
    forgotpass: ({ email }) => {
      return auth.sendPasswordResetEmail(email).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Password reset email sent",
        });
      });
    },
    changepass: ({ pass }) => {
      return auth.confirmPasswordReset(pass).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Your password has been changed",
        });
      });
    },
  };

  // Handle form submission
  const onSubmit = (inputFieldData) => {
    // Show pending indicator
    setPending(true);

    // Call submit handler for auth type
    submitHandlersByType[props.type](inputFieldData).catch((error) => {
      setPending(false);
      // Show error alert message
      props.onFormAlert({
        type: "error",
        message: error.message,
      });
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {["signup"].includes(props.type) && (
        <Form.Group controlId="formPhone">
          <FormField
            size="lg"
            name="phone"
            type="phone"
            placeholder="+37061234567"
            error={errors.phone}
            inputRef={register({
              required: "Prašome įvesti savo telefono nr.",
            })}
          />
        </Form.Group>
      )}
      {console.log(props.phone)}
      {["otp"].includes(props.type) && (
        <Form.Group controlId="formOtpCode">
          <FormField
            size="lg"
            name="otpCode"
            type="otpCode"
            placeholder="123456"
            error={errors.otpCode}
            inputRef={register({
              required: "Prašome įvesti kodą, gautą sms žinute",
            })}
          />
        </Form.Group>
      )}     
      <Button
        variant="primary"
        block={true}
        size="lg"
        type="submit"
        disabled={pending}
      >
        {!pending && <span>{props.typeValues.buttonText}</span>}

        {pending && (
          <Spinner
            animation="border"
            size="sm"
            role="status"
            aria-hidden={true}
            className="align-baseline"
          >
            <span className="sr-only">Loading...</span>
          </Spinner>
        )}
      </Button>
    </Form>
  );
}

export default AuthForm;
